import auth from '@middlewares/Auth';

export default [
  {
    url: '/communities',
    page: 'users/Index',
    name: 'managers',
    meta: {
      label: 'Community Managers',
      layout: 'Dashboard',
      middleware: [auth],
      role: {
        only: ['tourism-operator', 'tourist'],
      },
    },
    children: [
      {
        url: 'create',
        page: 'users/Create',
        name: 'new-manager',
        role: {
          only: ['tourism-operator'],
        },
      },
      {
        url: ':id',
        page: 'users/Create',
        name: 'edit-user',
        role: {
          only: ['tourism-operator'],
        },
      },
    ],
  },
  {
    url: '/operators',
    page: 'users/Index',
    name: 'operators',
    meta: {
      label: 'Operators',
      layout: 'Dashboard',
      middleware: [auth],
      role: {
        only: ['admin', 'tourist'],
      },
    },
    children: [
      {
        url: 'create',
        page: 'users/Create',
        name: 'new-operator',
        role: {
          only: ['admin'],
        },
      },
      {
        url: ':id',
        page: 'users/Create',
        name: 'edit-operator',
        role: {
          only: ['admin'],
        },
      },
    ],
  },
];
